module.exports = __webpack_public_path__ + "img/icon_integralMall.bbfba451.png";